<!-- src/pages/auth/register.vue -->
<template>
  <form @submit.prevent="handleSubmit">
    <section class="page-register">
      <div class="container d-flex justify-content-center align-items-center min-vh-100">
        <div class="card p-4">
          <!-- Logo -->
          <div class="text-center mb-4">
            <div class="app-logo mb-2" aria-hidden="true">
              <i class="fas fa-bolt text-primary fs-1"></i>
            </div>
            <h1 class="h4 fw-bold mb-1">NeXt Instalações</h1>
            <p class="text-muted mb-0">Acesse sua conta para continuar</p>
          </div>

          <!-- First Name -->
          <div class="mb-3 position-relative">
            <label for="first_name" class="form-label">{{ $t('page.auth.register.inputs.first_name') }}</label>
            <div class="position-relative">
              <i class="fas fa-user input-icon" aria-hidden="true"></i>
              <input id="first_name" type="text" class="form-control ps-5" :class="{ 'is-invalid': errors.first_name }" v-model.trim="formData.first_name" :placeholder="$t('page.auth.register.inputs.firstNamePlaceholder')" required autocomplete="first_name" />
            </div>
            <small v-if="errors.first_name" class="text-danger">{{ errors.first_name[0] }}</small>
          </div>

          <!-- Last Name -->
          <div class="mb-3 position-relative">
            <label for="last_name" class="form-label">{{ $t('page.auth.register.inputs.last_name') }}</label>
            <div class="position-relative">
              <i class="fas fa-user input-icon" aria-hidden="true"></i>
              <input id="last_name" type="text" class="form-control ps-5" :class="{ 'is-invalid': errors.last_name }" v-model.trim="formData.last_name" :placeholder="$t('page.auth.register.inputs.lastNamePlaceholder')" required autocomplete="last_name" />
            </div>
            <small v-if="errors.last_name" class="text-danger">{{ errors.last_name[0] }}</small>
          </div>

          <!-- Username -->
          <div class="mb-3 position-relative">
            <label for="username" class="form-label">{{ $t('page.auth.register.inputs.username') }}</label>
            <div class="position-relative">
              <i class="fas fa-user input-icon" aria-hidden="true"></i>
              <input id="username" type="text" class="form-control ps-5" :class="{ 'is-invalid': errors.username }" v-model.trim="formData.username" :placeholder="$t('page.auth.register.inputs.usernamePlaceholder')" required autocomplete="username" />
            </div>
            <small v-if="errors.username" class="text-danger">{{ errors.username[0] }}</small>
          </div>

          <!-- Email -->
          <div class="mb-3 position-relative">
            <label for="email" class="form-label">{{ $t('page.auth.register.inputs.email') }}</label>
            <div class="position-relative">
              <i class="fa-solid fa-envelope input-icon" aria-hidden="true"></i>
              <input id="email" type="email" class="form-control ps-5" :class="{ 'is-invalid': errors.email }" v-model.trim="formData.email" :placeholder="$t('page.auth.register.inputs.emailPlaceholder')" required autocomplete="email" />
            </div>
            <small v-if="errors.email" class="text-danger">{{ errors.email[0] }}</small>
          </div>

          <!-- Password -->
          <div class="mb-3 position-relative">
            <label for="password" class="form-label">{{ $t('page.auth.register.inputs.password') }}</label>
            <div class="position-relative">
              <i class="fas fa-lock input-icon" aria-hidden="true"></i>
              <input id="password" :type="showPassword ? 'text' : 'password'" class="form-control ps-5 pe-5" v-model="formData.password" :placeholder="$t('page.auth.register.inputs.passwordPlaceholder')" required autocomplete="current-password" aria-describedby="togglePassword" />

              <button id="togglePassword" type="button" class="btn btn-link password-toggle" :aria-pressed="String(showPassword)" :aria-label="showPassword ? $t('page.auth.register.hide_password') : $t('page.auth.register.show_password')" @click="togglePassword">
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
            <small v-if="errors.password" class="text-danger">{{ errors.password[0] }}</small>
          </div>

          <!-- Confirm Password -->
          <div class="mb-3 position-relative">
            <label for="confirm_password" class="form-label">{{ $t('page.auth.register.inputs.confirm_password') }}</label>
            <div class="position-relative">
              <i class="fas fa-lock input-icon" aria-hidden="true"></i>
              <input id="confirm_password" :type="showConfirmPassword ? 'text' : 'password'" class="form-control ps-5 pe-5" v-model="formData.confirm_password" :placeholder="$t('page.auth.register.inputs.passwordPlaceholder')" required autocomplete="current-password" aria-describedby="toggleConfirmPassword" />

              <button id="toggleConfirmPassword" type="button" class="btn btn-link password-toggle" :aria-label="showConfirmPassword ? $t('page.auth.register.hide_password') : $t('page.auth.register.show_password')" @click="toggleConfirmPassword">
                <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
          </div>

          <!-- Checkbox -->
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" id="terms" v-model="formData.terms" required />
            <label class="form-check-label" for="terms">
              I agree to the <a href="#">terms and conditions</a>
            </label>
          </div>

          <!-- Botão -->
          <div class="d-grid">
            <button class="btn btn-primary" type="submit">
              {{ loading ? $t('page.auth.register.signing_up') : $t('page.auth.register.sign_up') }}
            </button>
          </div>

          <!-- SingIn -->
          <div class="text-center">
            <p class="small text-muted">
              {{ $t('page.auth.register.already_account') }}
              <router-link :to="{ name: 'login' }" class="fw-semibold text-decoration-none">
                {{ $t('page.auth.register.go_login') }}
              </router-link>
            </p>
          </div>

          <!-- Footer -->
          <div class="text-center mt-3">
            <small class="text-muted">© 2019 - {{ new Date().getFullYear() }} Next Instalações</small>
          </div>
        </div>
      </div>
    </section>
  </form>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/authStore";
import Cookies from "js-cookie";

// Consts
const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

// States
const formData = ref({
  first_name: "",
  last_name: "",
  username: "",
  email: "",
  password: "",
  confirm_password: "",
  terms: false,
  referral: null,
});
const showPassword = ref(false);
const showConfirmPassword = ref(false);
const loading = ref(false);
const errors = ref({});

const togglePassword = () => (showPassword.value = !showPassword.value);
const toggleConfirmPassword = () => (showConfirmPassword.value = !showConfirmPassword.value);

// Submit
const handleSubmit = async () => {
  if (formData.value.password !== formData.value.confirm_password) {
    alert("Passwords do not match!");
    return;
  }

  loading.value = true;
  errors.value = {};
  try {
    await authStore.register(formData.value);
    Cookies.remove("referral");
    router.push({ name: "home" }).catch(() => { });
  } catch (error) {
    if (error.response?.data?.errors) {
      errors.value = error.response.data.errors;
    }
  } finally {
    loading.value = false;
  }
};

// Mounted
onMounted(() => {
  if (authStore.isAuthenticated) {
    router.push({ name: "home" }).catch(() => { });
  }

  // Referral logic: pega o primeiro referral e salva no cookie
  const referralFromQuery = route.query.ref;
  const referralFromCookie = Cookies.get("referral");

  if (referralFromCookie) {
    // Mantém o primeiro referral salvo
    formData.value.referral = referralFromCookie;
  } else if (referralFromQuery) {
    formData.value.referral = referralFromQuery;
    Cookies.set("referral", referralFromQuery, { expires: 30 }); // 30 dias
  } else {
    formData.value.referral = null;
  }
});
</script>

<style scoped>
.page-register {
  background: linear-gradient(135deg, #2c3e50, #4a6580);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.card {
  width: 100%;
  max-width: 420px;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

.app-logo {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.input-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 0.95rem;
  pointer-events: none;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  background: transparent;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
}

.password-toggle:focus {
  outline: none;
  box-shadow: none;
}

.form-control.ps-5 {
  padding-left: 2.5rem !important;
}

.form-control.pe-5 {
  padding-right: 2.5rem !important;
}

.form-control {
  height: 44px;
  border-radius: 8px;
}

.btn {
  height: 44px;
  border-radius: 8px;
}

@media (max-width: 576px) {
  .page-register {
    background: none;
  }

  .card {
    border: none;
    border-radius: none;
    box-shadow: none !important;
  }
}
</style>
